import React, { useState, useEffect, Fragment, useRef } from "react";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import MakeAPICall from "../../apiCalls/common";
import {
  marketingFileUpload,
  promotionSendAPI,
  promotionEmailListAPI,
  marketingPatientExportListAPI
} from "../../apiRoutes";
import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import CustomDataTable from "../../components/datatable/customDataTable";
import ICCheckbox from "../../components/form/checkbox";
import momentTz from "moment-timezone";
import moment from "moment";
import { KeyboardDatePicker } from "@material-ui/pickers";
import _ from "lodash";
import { TextField } from "@material-ui/core";

const PromotionsPage = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);

  // export patient list
  const [isExportModelOpen, setIsExportModelOpen] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(30, 'days').toISOString());
  const [endDate, setEndDate] = useState(moment().toISOString());
  const [selectedState, setSelectedState] = useState('');

  const csvDownRef = useRef(null);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [excelSheetHeader, setExcelSheetHeader] = useState(null);
  let excelSheetHeaderNeverUsed = [
    {
      label: "Date of Registration",
      key: "createdAt"
    },
    {
      label: "Email",
      key: "email"
    },
    {
      label: "OptOutMarketing",
      key: "optOutMarketingEmails"
    }
  ];

  let excelSheetHeaderSuccessfulConsult = [
    {
      label: "Date of Successful Consult",
      key: "createdAt"
    },
    {
      label: "Email",
      key: "email"
    },
    {
      label: "Star Rating",
      key: "rating"
    },
    {
      label: "OptOutMarketing",
      key: "optOutMarketingEmails"
    }
  ];


  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });

  const tableHeaders = [
    {
      key: "createdDate",
      value: "Date"
    },
    { key: "isPatient", value: "Patients" },
    { key: "isDoctor", value: "Doctors" },
    { key: "isCustomEmail", value: "Custom" },
    { key: "subject", value: "Subject" },
    { key: "sentCount", value: "Count" },
    { key: "file", value: "HTML File" }
  ];

  const [emails, setEmails] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [successFileUploadModal, setSuccessFileUploadModal] = useState(false);
  const [successFileUrl, setSuccessFileUrl] = useState("");

  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const [htmlFile, setHtmlFile] = useState(null);

  const [emailSubject, setEmailSubject] = useState("");
  const [
    openPromotionConformationModal,
    setOpenPromotionConformationModal
  ] = useState(false);
  const [emailsSendSuccessModel, setEmailsSendSuccessModel] = useState(false);
  const [sentToPatient, setSentToPatient] = useState(false);
  const [sentToDoctor, setSentToDoctor] = useState(false);

  const [isCustomEmail, setIsCustomEmail] = useState(false);
  const [isCustomCSVModalOpen, setIsCustomCSVModalOpen] = useState(false);
  const [csvFile, setCSVFile] = useState(null);
  const [csvFileError, setCSVFileError] = useState(false);
  const [enablePatientDoctorEmail, setEnablePatientDoctorEmail] = useState(false);

  // validate input file

  const handleFileUpload = event => {
    let fileEvent = event;
    let file = event.currentTarget.files[0];
    setIsProcessing(true);
    var form = new FormData();
    form.append("photo", file);
    setApiCallParams({
      reqType: "POST",
      reqUrl: marketingFileUpload,
      dataObj: form,
      successCallback: async res => {
        console.log("Res: ", res);
        setIsProcessing(false);
        setSuccessFileUrl(res.data.data.original);
        setSuccessFileUploadModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const handleHTMLFile = event => {
    setHtmlFile(event.currentTarget.files[0]);
  };

  const handleCSVFile = event => {
    setCSVFile(event.currentTarget.files[0]);
  }

  const handleSubjectChnage = event => {
    setEmailSubject(event.target.value);
  };

  const acceptCustomEmailCSV = () => {
    setCSVFileError(false);
    if (!csvFile) {
      setCSVFileError(true);
      return;
    } else {
      setIsCustomCSVModalOpen(false);
    }
  }

  const sendPromotionEmail = event => {
    if (
      htmlFile !== null &&
      emailSubject !== "" &&
      // (sentToPatient === true || sentToDoctor === true || isCustomEmail === true)
      ((sentToPatient === true || sentToDoctor === true) || (isCustomEmail === true && csvFile !== null) )
    ) {
      console.log("Now sending promotion email");
      let form = new FormData();
      form.append("htmlFile", htmlFile);
      form.append("emailSubject", emailSubject);
      form.append("isPatient", sentToPatient);
      form.append("isDoctor", sentToDoctor);
      form.append("isCustomEmail", isCustomEmail);

      if ((sentToPatient || sentToDoctor) && selectedState) {
        form.append("state", selectedState);
      }

      if (isCustomEmail) {
        form.append("csvFile", csvFile);
      }

      setApiCallParams({
        reqType: "POST",
        reqUrl: promotionSendAPI,
        dataObj: form,
        successCallback: async res => {
          console.log("Res: ", res);
          setIsProcessing(false);
          setEmailSubject("");
          setEmailsSendSuccessModel(true);
          getPromotionEmailsListData();
          setSentToDoctor(false);
          setSentToPatient(false);
          setIsCustomEmail(false);
          setOpenPromotionConformationModal(false);
        },
        failureCallback: err => {
          setIsProcessing(false);
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          setOpenPromotionConformationModal(false);
          //setShowErrModal(true);
          setEmailSubject("");
          setSentToDoctor(false);
          setSentToPatient(false);
        },
        timeout: 180000
      });
    } else {
      setErrModalText(
        "HTML File, Email, Subject, and Patient or Doctor Tick are required OR CSV file is required for custom email list"
      );
      setShowErrModal(true);
      setOpenPromotionConformationModal(false);
    }
  };

  // get the staff list
  const getPromotionEmailsListData = () => {
    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: promotionEmailListAPI,
      params: currFilters,
      successCallback: async res => {
        let emailList = [];

        await res.data.data.emails.forEach(column => {
          let d = {};

          d._id = column._id;
          d.subject = column.subject;
          d.sentCount = column.sentCount;
          d.file = column.file;
          d.isDoctor = column.isDoctor ? column.isDoctor : false;
          d.isPatient = column.isPatient ? column.isPatient : false;
          d.isCustomEmail = column.isCustomEmail ? column.isCustomEmail : false;
          d.createdDate = momentTz(column.createdDate)
            .tz("Australia/Brisbane")
            .format("DD-MM-YYYY hh:mm A");
          emailList.push(d);
        });
        setEmails(emailList);
        setTotalRecords(res.data.data.count);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    setCurrFilters(newFilter);
  };

  const hanldePatinetTickBox = (event, value) => {
    setSentToPatient(value);
  };

  const hanldeDoctorTickBox = (event, value) => {
    setSentToDoctor(value);
  };

  const hanldeCustomEmailTickBox = (event, value) => {
    setCSVFileError(false);
    setIsCustomEmail(value);
    setIsCustomCSVModalOpen(value);
    setEnablePatientDoctorEmail(value);
    if(value) {
      setSentToPatient(false);
      setSentToDoctor(false);
    }
  };

  const handleMarketingEmailBtn = () => {
    setOpenPromotionConformationModal(true);
  };

  const openExportModel = () => {
    setIsExportModelOpen(true);
  }

  // this function will export a csv file of patient who had a successful consult prior 30 days
  const handleExportPatientList = (exportObj) => {
    setIsExportModelOpen(false);
    const dataToSend = {
      isNeverUsed: exportObj.isNeverUsed,
      startDate: startDate,
      endDate: endDate
    };
    console.log("Data to send: ", dataToSend);
    setIsProcessing(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: marketingPatientExportListAPI,
      params: {},
      dataObj: dataToSend,
      successCallback: async res => {
        let emailList = [];
        if (res.data && res.data.data && res.data.data.neverUsedList.length) {
          await res.data.data.neverUsedList.map((data, index) => {
            emailList.push({
              email: data.email ? data.email.replace(/#/gi, "") : '',
              createdAt: moment(data.createdAt).format("DD-MM-YYYY"),
              optOutMarketingEmails: data.optOutMarketingEmails ? 'Y' : ''
            });
          });
        }

        if (res.data && res.data.data && res.data.data.priorSuccessfulConsults.length) {
          await res.data.data.priorSuccessfulConsults.map((data, index) => {
            if (data.patientId && data.patientId.email) {
              emailList.push({
                email: data.patientId && data.patientId.email ? data.patientId.email.replace(/#/gi, "") : '',
                createdAt: moment(data.createdAt).format("DD-MM-YYYY"),
                rating: data.rating || 0,
                optOutMarketingEmails: data.patientId && data.patientId.optOutMarketingEmails ? 'Y' : ''
              });

            }
          });
        }

        const uniqueEmailList = _.unionBy(emailList, 'email');

        if (exportObj.isNeverUsed) {
          await setExcelSheetHeader(excelSheetHeaderNeverUsed);
        } else {
          await setExcelSheetHeader(excelSheetHeaderSuccessfulConsult);
        }

        await setExcelSheetData(uniqueEmailList);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        console.log("Something wrong during marketing export patient list: ", err);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  }

  useEffect(() => {
    getPromotionEmailsListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  return (
    <div className="view-ticket-container">
      {isProcessing && <Loader />}
      <div className="d-flex flex-row flex-wrap justify-content-between">
        <h3>Marketing</h3>

        <Button
          // clickEvent={sendPromotionEmail}
          clickEvent={openExportModel}
          title="Export to CSV"
          className="mt-3 min-width-auto"
        ></Button>

      </div>
      <div className="row p-3">
        {/* <div className="col-sm-12 pl-0 pr-0">
          <div className="card p-4">
            <p>Upload Photos</p>
            <input
              type="file"
              onChange={event => {
                handleFileUpload(event);
              }}
            />
          </div>
        </div> */}
        <div className="col-sm-12 card p-3 mt-4 pr-3">
          <div className="row ">
            <div className="col-sm-3">
              <p className="mb-0 pb-0">Email Subject</p>
              <ICInput
                type="text"
                value={emailSubject}
                className="form-control mb-2"
                placeholder="Email Subject"
                onChange={event => {
                  handleSubjectChnage(event);
                }}
              />
            </div>

            <div className="col-sm-2 overflow-hidden">
              <p className="mb-0 pb-0">Choose HTML File</p>

              <input
                type="file"
                accept=".html"
                className="mt-1"
                onChange={event => {
                  handleHTMLFile(event);
                }}
              />
            </div>

            <div className="col-sm pt-3">
              <ICCheckbox
                name="isPatient"
                onChange={(event, value) => {
                  hanldePatinetTickBox(event, value);
                }}
                value={sentToPatient}
                checked={sentToPatient}
                label="Patients"
                disabled={enablePatientDoctorEmail}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
              <ICCheckbox
                name="isDoctor"
                onChange={(event, value) => {
                  hanldeDoctorTickBox(event, value);
                }}
                value={sentToDoctor}
                checked={sentToDoctor}
                label="Doctors"
                disabled={enablePatientDoctorEmail}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
              <ICCheckbox
                name="isCustom"
                onChange={(event, value) => {
                  hanldeCustomEmailTickBox(event, value);
                }}
                value={isCustomEmail}
                checked={isCustomEmail}
                label="Custom"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </div>

            {(sentToDoctor || sentToPatient) && (
              <div className="col-sm pt-3">
                <TextField
                  name="selectState"
                  className="w-100"
                  select
                  value={selectedState}
                  SelectProps={{
                    native: true
                  }}
                  onChange={(event) => {
                    const state = event.target.value;
                    setSelectedState(state);
                  }}
                >
                  <option>Select State</option>
                  <option value="">All</option>
                  <option value="ACT">ACT</option>
                  <option value="NSW">NSW</option>
                  <option value="NT">NT</option>
                  <option value="QLD">QLD</option>
                  <option value="SA">SA</option>
                  <option value="TAS">TAS</option>
                  <option value="VIC">VIC</option>
                  <option value="WA">WA</option>
                </TextField>
              </div>
            )}


            <div className="col-sm-3">
              <Button
                // clickEvent={sendPromotionEmail}
                clickEvent={handleMarketingEmailBtn}
                title="Send Marketing Email"
                className="mt-3"
              ></Button>
            </div>
          </div>
        </div>
      </div>
      <div className="row p-0 m-0">
        <div className="col-sm-12 pl-0 pr-0">
          <CustomDataTable
            totalRecords={totalRecords}
            headers={tableHeaders}
            tabFilters={currFilters}
            sortableTable={false}
            setFilters={setTableFilters}
            disableTopFilters={true}
          >
            {emails.length > 0 &&
              emails.map((email, index) => (
                <tr key={index}>
                  <td className="td-no-hover">
                    <p className="mb-0"> {email.createdDate}</p>
                  </td>
                  <td className="td-no-hover">
                    {email.isPatient ? (
                      <i className="fas fa-check success-msg"></i>
                    ) : (
                      <i className="fas fa-times error"></i>
                    )}
                  </td>
                  <td className="td-no-hover">
                    {email.isDoctor ? (
                      <i className="fas fa-check success-msg"></i>
                    ) : (
                      <i className="fas fa-times error"></i>
                    )}
                  </td>
                  <td className="td-no-hover">
                    {email.isCustomEmail ? (
                      <i className="fas fa-check success-msg"></i>
                    ) : (
                      <i className="fas fa-times error"></i>
                    )}
                  </td>
                  <td className="td-no-hover">
                    <p className="mb-0"> {email.subject}</p>
                  </td>
                  <td className="td-no-hover">
                    <p className="mb-0"> {email.sentCount}</p>
                  </td>
                  <td className="td-no-hover">
                    <a
                      href={email.file}
                      target="_blank"
                      className="legal-link text-decoration-none"
                    >
                      File
                    </a>
                  </td>
                </tr>
              ))}
          </CustomDataTable>
        </div>
      </div>

      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />

      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={successFileUploadModal}
        className="modal-lg"
        cancelEvent={() => {
          setSuccessFileUploadModal(false);
        }}
        modalBodyContent={
          <p className="text-center mb-0">File Url: {successFileUrl}</p>
        }
      />

      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={emailsSendSuccessModel}
        cancelEvent={() => {
          setEmailsSendSuccessModel(false);
        }}
        modalBodyContent={
          <p className="text-center mb-0">Marketing Email Sent Successfully</p>
        }
      />

      <CustomModal
        cancelText="Cancel"
        openModal={openPromotionConformationModal}
        cancelEvent={() => {
          setOpenPromotionConformationModal(false);
        }}
        okayText={"Send"}
        okayEvent={sendPromotionEmail}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to send this email?
          </p>
        }
      />

      <CustomModal
        cancelText="Cancel"
        openModal={isCustomCSVModalOpen}
        cancelEvent={() => {
          setIsCustomCSVModalOpen(false);
          setIsCustomEmail(false);
          setEnablePatientDoctorEmail(false);
        }}
        okayText={"Upload"}
        okayEvent={acceptCustomEmailCSV}
        title="Custom Marketing Email"
        modalBodyContent={
          <Fragment>
            <p className="mb-0 pb-0">Choose CSV File</p>

            <input
              type="file"
              accept=".csv"
              className="mt-1"
              onChange={event => {
                handleCSVFile(event);
              }}
            />

            {
              csvFileError && (
                <p className="error mt-2">Please select CSV file</p>
              )
            }
          </Fragment>
        }
        backdrop="static"
      />

      <CustomModal
        cancelText="Close"
        openModal={isExportModelOpen}
        cancelEvent={() => {
          setIsExportModelOpen(false);
        }}
        useOneButton={true}
        // okayText={"Upload"}
        // okayEvent={acceptCustomEmailCSV}
        title="Export Patient List"
        modalBodyContent={
          <Fragment>
            <div className="row">
              <div className="col-sm-12 text-center mb-4">
                <KeyboardDatePicker
                  name="startDate"
                  style={{ width: "135px" }}
                  autoOk
                  variant="inline"
                  mask="__-__-____"
                  format="DD-MM-YYYY"
                  label="Start Date"
                  value={startDate}
                  onChange={date => setStartDate(date.toISOString())}
                />
                <KeyboardDatePicker
                  name="endDate"
                  style={{ width: "135px", marginLeft: "20px" }}
                  autoOk
                  variant="inline"
                  mask="__-__-____"
                  format="DD-MM-YYYY"
                  label="End Date"
                  value={endDate}
                  onChange={date => setEndDate(date.toISOString())}
                />
              </div>
              <div className="col-sm-6">
                <Button
                  clickEvent={() => handleExportPatientList({ isSuccessfulConsult: true, isNeverUsed: false })}
                  title="Successful Consult"
                  className="mt-3 mx-auto ic-btn-transparent-navy-blue"
                ></Button>
              </div>
              <div className="col-sm-6">
                <Button
                  clickEvent={() => handleExportPatientList({ isSuccessfulConsult: false, isNeverUsed: true })}
                  title="Never Used"
                  className="mt-3 mx-auto ic-btn-transparent-navy-blue"
                ></Button>
              </div>
            </div>
          </Fragment>
        }
        backdrop="static"
      />

      <CSVLink
        style={{ display: "none" }}
        ref={csvDownRef}
        className="no-text-decoration"
        filename={"PatientList.csv"}
        data={excelSheetData}
        headers={excelSheetHeader}
      ></CSVLink>

      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
});

export default connect(mapStateToProps, null)(PromotionsPage);
